import { createSlice } from '@reduxjs/toolkit'

const persistantDataSlice = createSlice({
  name: 'persistantData',
  initialState: {
    selectedDestinations: [],
    selectedDates: {},
    confirmedPlanData: [],
    planEffectiveDate: '',
    selectedDeviceDetailsUnauth:{},
    devicesData : [],
    onlyCruise : false,
    reptoolOpened:false,
    deviceAndPlansPayload:{}
  },
  reducers: {
    savePersistantDestinations: (state, param) => {
      const { payload } = param;
      state.selectedDestinations = payload;
    },
    savePersistantDates: (state, param) => {
      const { payload } = param;
      state.selectedDates = payload;
    },
    
    clearSelectedPlanFromConfirm:(state, param) => {
      let { payload } = param;
      const updatedData = state.confirmedPlanData.filter(item => 
         item.mtn !== payload
      )
      state.confirmedPlanData = updatedData;
    },
    saveConfirmedPlanData:(state, param) => {
      let { payload } = param;
      state.confirmedPlanData = payload;
    },
    clearConfirmedPlanData:(state) => {
      state.confirmedPlanData = [],
      state.planEffectiveDate = ''
    },
    savePlanEffectiveDate: (state, param) => {
      let { payload } = param;
      state.planEffectiveDate = payload;
    },
    saveSelectedDeviceDetailsUnauth:(state, param) => {
      const { payload } = param;
      state.selectedDeviceDetailsUnauth = payload;
    },
    saveDeviceDetails:(state, param) => {
      const { payload } = param;
      state.devicesData = payload;
    },
    setOnlyCruise:(state, param) => {
      const { payload } = param;
      state.onlyCruise = payload;
    },
    setReptoolOpened:(state, param) => {
      const { payload } = param;
      state.reptoolOpened = payload;
    },
    saveDevicesAndPlansPayload:(state, param) => {
      const { payload } = param;
      state.deviceAndPlansPayload = payload;
    },
    
  },
})

const { actions, reducer } = persistantDataSlice;
export const { savePersistantDestinations, savePersistantDates, clearSelectedPlanFromConfirm, saveConfirmedPlanData, clearConfirmedPlanData, savePlanEffectiveDate,saveSelectedDeviceDetailsUnauth,saveDeviceDetails,setReptoolOpened, setOnlyCruise,saveDevicesAndPlansPayload} = actions;
export default reducer;



